import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'vendor-report-sections';

const VendorReportSectionsGenerator = createRestAPIModelGenerator(TYPE);
export default VendorReportSectionsGenerator.createValueListModel();
